import React from 'react';
import styled from "styled-components/macro";
import colors from "../../styles/variables/colors";
import {useAtom} from "jotai";
import {filteredNodesAtom} from "../../atoms/atoms";

type ResultActionButtonComponent = () => JSX.Element;

const Wrapper = styled.div`
  background-color: ${colors.slate["10"]};
  padding: 30px;

  @media (min-width: 1024px) {
    padding-top: 0;
  }
`;

const ActionButton = styled.a`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  background-color: ${colors.blue.base};
  height: 70px;
  border-radius: 5px;
  color: ${colors.white.base};
  cursor: pointer;
  justify-content: center;
  align-items: center;
  max-width: 100%;

  &:hover {
    background-color: ${colors.blue['90']};
  }
  &:active {
    background-color: ${colors.blue['90']};
    transform: scale(0.98);
  }
`;

const TextSmall = styled.div`
  flex: 0 0 100%;
  font-family: "Helvetica Now Micro W01 Medium", sans-serif;
  font-size: 13px;
  padding-bottom: 10px;
  letter-spacing: -0.2%;
  font-weight: 500;
  text-align: center;
  margin-top:-5px;
`
const TextLarge = styled.div`
  font-family: "Helvetica Now Text W01 Bold", sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 24px;
`;

const ResultActionButton: ResultActionButtonComponent = () => {

  const [products] = useAtom(filteredNodesAtom);
  const persistInfo = () => {
    const productIds = products.map(product => {
      return product.id
    });
    localStorage.setItem('sopm_products', JSON.stringify(productIds));
    return true;
  }

  return (
    <Wrapper>
      <ActionButton href={'/produktberatung'} onClick={persistInfo} target={'_blank'}>
        <TextLarge>Jetzt Offerte anfordern</TextLarge>
      </ActionButton>
    </Wrapper>
  )
}

export default ResultActionButton;
